import React from 'react';
import { Mail, Phone, MapPin, Twitter, Linkedin, Instagram, Facebook, Youtube, Github } from 'lucide-react';
import Logo from './Logo';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#103541] text-white pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-x-12 gap-y-8 mb-12">
          <div>
            <h5 className="text-lg font-semibold mb-4">Empresa</h5>
            <ul className="space-y-4">
              <li>
                <a href="https://nfe.io/sobre/" className="text-gray-300 hover:text-white transition-colors">
                  Quem Somos
                </a>
              </li>
              <li>
                <a href="https://nfe.io/cases/" className="text-gray-300 hover:text-white transition-colors">
                  Cases de Sucesso
                </a>
              </li>
              <li>
                <a href="https://nfe.io/carreiras/" className="text-gray-300 hover:text-white transition-colors">
                  Carreiras
                </a>
              </li>
              <li>
                <a href="https://nfe.io/blog" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  Blog
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-semibold mb-4">Planos</h5>
            <ul className="space-y-4">
              <li>
                <a href="https://nfe.io/precos/emissao-nfse/" className="text-gray-300 hover:text-white transition-colors">
                  NF de Serviço
                </a>
              </li>
              <li>
                <a href="https://nfe.io/precos/emissao-nfe/" className="text-gray-300 hover:text-white transition-colors">
                  NF de Produto
                </a>
              </li>
              <li>
                <a href="https://nfe.io/precos/emissao-nfce/" className="text-gray-300 hover:text-white transition-colors">
                  NF de Consumidor
                </a>
              </li>
              <li>
                <a href="https://nfe.io/consulta-cpf/" className="text-gray-300 hover:text-white transition-colors">
                  Pessoa Física
                </a>
              </li>
              <li>
                <a href="https://nfe.io/consulta-cnpj/" className="text-gray-300 hover:text-white transition-colors">
                  Pessoa Jurídica
                </a>
              </li>
              <li>
                <a href="https://nfe.io/consulta-nota-fiscal/" className="text-gray-300 hover:text-white transition-colors">
                  Notas Fiscais
                </a>
              </li>
              <li>
                <a href="https://nfe.io/consulta-endereco/" className="text-gray-300 hover:text-white transition-colors">
                  Endereço
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-semibold mb-4">Emissões</h5>
            <ul className="space-y-4">
              <li>
                <a href="https://nfe.io/nota-fiscal-de-produto-eletronica/" className="text-gray-300 hover:text-white transition-colors">
                  NF Produto
                </a>
              </li>
              <li>
                <a href="https://nfe.io/nota-fiscal-de-servico-eletronica/" className="text-gray-300 hover:text-white transition-colors">
                  NF Serviço
                </a>
              </li>
              <li>
                <a href="https://nfe.io/nota-fiscal-de-consumidor-eletronica/" className="text-gray-300 hover:text-white transition-colors">
                  NF Consumidor
                </a>
              </li>
              <li>
                <a href="https://nfe.io/contato/" className="text-gray-300 hover:text-white transition-colors">
                  Contato
                </a>
              </li>
              <li>
                <a href="mailto:suporte@nfe.io" className="text-gray-300 hover:text-white transition-colors">
                  Suporte
                </a>
              </li>
              <li>
                <a href="https://status.nfe.io/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  Status
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-semibold mb-4">Segmentos</h5>
            <ul className="space-y-4">
              <li>
                <a href="https://nfe.io/segmentos/transportadoras/" className="text-gray-300 hover:text-white transition-colors">
                  Transportadoras
                </a>
              </li>
              <li>
                <a href="https://nfe.io/segmentos/financeiras/" className="text-gray-300 hover:text-white transition-colors">
                  Financeiras
                </a>
              </li>
              <li>
                <a href="https://nfe.io/segmentos/saas-academias-clinicas/" className="text-gray-300 hover:text-white transition-colors">
                  SaaS / Academias
                </a>
              </li>
              <li>
                <a href="https://nfe.io/segmentos/software-house-erps/" className="text-gray-300 hover:text-white transition-colors">
                  Software House e ERPs
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <hr className="border-white/10 my-12" />

        <div className="grid md:grid-cols-12 gap-8">
          <div className="md:col-span-5">
            <p className="font-semibold text-lg mb-2">NFE.io © 2025 - Todos os Direitos Reservados</p>
            <p className="text-gray-300 text-sm mb-4">
              Fornecemos soluções robustas para empresas, incluindo <strong>emissão de notas fiscais eletrônicas, consultas de CPF, CNPJ e notas fiscais, além de cálculo automático de impostos.</strong> Simplifique a gestão fiscal da sua empresa com nossas ferramentas eficientes e integradas.
            </p>
            <div className="space-y-2 text-gray-300 text-sm">
              <p>Endereço: Rua Cláudio Soares, 72 - Conj 1701 - Edifício Ahead - Pinheiros, São Paulo - SP, CEP: 05422-030</p>
              <p>CNPJ: 18.792.479/0001-01</p>
            </div>
          </div>
          
          <div className="md:col-span-7">
            <div className="flex flex-col md:flex-row justify-between gap-8">
              <div className="flex flex-wrap gap-6">
                <a href="https://p.nfe.io/pt-br/termos-de-servico" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  Termos de serviço
                </a>
                <a href="https://p.nfe.io/pt-br/pt-br/politica_de_privacidade" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  Política de privacidade
                </a>
              </div>
              
              <div className="flex items-center gap-4">
                <a href="https://www.linkedin.com/company/nfe-io/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Linkedin size={20} />
                </a>
                <a href="https://github.com/nfe" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Github size={20} />
                </a>
                <a href="https://facebook.com/nfe.io" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Facebook size={20} />
                </a>
                <a href="https://www.youtube.com/channel/UCB1PFw8rxeIN64k_t5FWEAQ" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Youtube size={20} />
                </a>
                <a href="https://twitter.com/nfe_io" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Twitter size={20} />
                </a>
                <a href="https://www.instagram.com/nfe.io/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors">
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;